import { addToast } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { Card } from 'reactstrap';

import { PathsLayouts } from '../../../../config/routes';
import { Discount } from '../api/discount';
import { DiscountForm } from './parts/DiscountForm';

const DiscountFormView = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();
  const prefix = 'tariffAndTuition.discounts';

  const recordToEdit: Discount | null = id
    ? ({ id: Number(id) } as Discount)
    : null;

  const handleSubmit = (result: any) => {
    if (result.data) {
      addToast({
        icon: 'check',
        text: id ? t(`${prefix}.editChanges`) : t(`${prefix}.saveChanges`),
        color: 'success',
      });
      history.push(`${PathsLayouts.tariffAndTuiton}/discounts`);
    } else {
      addToast({
        icon: 'error',
        text: t('common.errors.save'),
        color: 'danger',
      });
    }
  };

  const handleCancel = () => {
    history.push(`${PathsLayouts.tariffAndTuiton}/discounts`);
  };

  return (
    <Card className="mx-3">
      <DiscountForm
        recordToEdit={recordToEdit}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </Card>
  );
};

export default DiscountFormView;
